import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Sprout, Briefcase, ArrowRight } from "lucide-react";

export default function LoginLanding() {
  const { t } = useTranslation();
  return (
    <div data-testid="page-login" className="max-w-4xl mx-auto px-6 py-24">
      <div className="tr-eyebrow">{t("auth.eyebrow")}</div>
      <h1 className="tr-section-title text-4xl lg:text-6xl mt-4">{t("auth.title")}</h1>
      <p className="mt-4 text-[var(--tr-muted)] text-lg">{t("auth.subtitle")}</p>
      <div className="mt-12 grid grid-cols-1 md:grid-cols-2 gap-6">
        <Link data-testid="login-role-farmer" to="/login/farmer" className="tr-card p-8 tr-nolink group">
          <Sprout className="w-8 h-8 text-[var(--tr-zest)]" />
          <div className="mt-4 font-display font-extrabold text-2xl text-[var(--tr-deep-green)]">{t("auth.farmer_title")}</div>
          <p className="mt-2 text-[var(--tr-muted)]">{t("auth.farmer_body")}</p>
          <div className="mt-5 inline-flex items-center gap-1 text-sm font-semibold text-[var(--tr-deep-green)]">{t("auth.continue")} <ArrowRight className="w-4 h-4" /></div>
        </Link>
        <Link data-testid="login-role-staff" to="/login/staff" className="tr-card p-8 tr-nolink group">
          <Briefcase className="w-8 h-8 text-[var(--tr-zest)]" />
          <div className="mt-4 font-display font-extrabold text-2xl text-[var(--tr-deep-green)]">{t("auth.staff_title")}</div>
          <p className="mt-2 text-[var(--tr-muted)]">{t("auth.staff_body")}</p>
          <div className="mt-5 inline-flex items-center gap-1 text-sm font-semibold text-[var(--tr-deep-green)]">{t("auth.continue")} <ArrowRight className="w-4 h-4" /></div>
        </Link>
      </div>
    </div>
  );
}
